module.exports = __webpack_public_path__ + "static/media/plusgreen.c8845376.svg";